<template>

<v-dialog v-model="dialog" width="500px">
  <v-card>
    <p class=".title ma-2">Add Credits to guest {{kltg.klnt_code}}  {{kltg.klnt_naam}}</p>
    <v-form ref="addKltg" v-model="addKltgValid">
     <v-row no-gutters>
      <v-col class="ma-2">
       <v-text-field v-model="kltg_bedrag" label="Amount" :rules="kltg_bedragRule"></v-text-field>
      </v-col>
     </v-row>  
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="addKltg" :disabled="!addKltgValid">Save</v-btn>
      <v-btn color="primary" small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      addKltgValid: false,
      klnt_encrid: null,
      kltg_bedrag: '',
      kltg: {},
      kltg_bedragRule: [v => (!isNaN(parseFloat(v)) && v > 0) || 'An amount is mandatory'],
      eign_codeRules: [
          v => (v && v.length >= 3) || "A Host ID is requird"
      ]
    }
  },
  methods: {
    open(klnt_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/klnt/kltg/getKlntToAddKltg.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getKlntToAddKltg"
          },
          getKlntToAddKltg: {
            klnt_encrid: klnt_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.kltg = res.data.getKlntToAddKltg;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addKltg() { 
      this.$axios
        .post("ares/json/ares/klnt/kltg/addKltg.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addKltg"
          },
          addKltg: {
            klnt_encrid: this.kltg.klnt_encrid,
            kltg_bedrag: parseFloat(this.kltg_bedrag)
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 

             if (res.data.addKltg.color == "success") { 
                setTimeout(() => { this.$router.reload('/klnt/onKlnt/' + res.data.addKltg.klnt_encrid);  }, 2000);      
             }         
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.addKltg.text,
              color: res.data.addKltg.color
            }); 
            this.dialog = false;
          }
        })
    },
  }
}
</script>

